import { API } from 'aws-amplify';
const USER = `
  {
    id
    email
    name
    company
    accountConfirmed
  }
`;
const USERS = `
  {
    users ${USER}
    nextToken
  }
`;
const ADMIN_LIBRARY_LINKS = `
{
  editLibrary
  viewMasterLibrary
  viewCollections
  submitNewProduct
  submitEqual
}
`;
const GROUP = `
  {
    name
  }
`;
const WORKSPACE_CONNECTION = `
{
  data{
    status
    id
    name
    type
    licenses
    description
    premiumLicenses
    usedLicenses
    freeLicenses
    guestLicenseLimit
    usedGuestLicenses
    unlimitedUsers
    allowPages
    verified
    isVerified
    creator
      ${USER}

  }
  nextToken
}
`;
const TYPES = `
  {
    type
    string
    integer
    float
  }
`;
const FEATURE_FLAG = `
  {
    name
    enabled
    value ${TYPES}
  }
`;
export default {
  changeEmailAddress(variables) {
    const query = `
    mutation changeEmailAddress (
      $userId: String!
      $email: String!
    ){
      changeEmailAddress(
        userId:$userId
        email: $email
      ) {
      id
      email
      }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  changeUserGroups(variables) {
    const query = `
    mutation changeUserGroups (
        $userId: String!
        $groupsToAdd: [String]!
        $groupsToRemove: [String]!
      ) {
        response: changeUserGroups(
          userId: $userId
          groupsToAdd: $groupsToAdd
          groupsToRemove: $groupsToRemove
        ) ${USER}
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  createUser(variables) {
    const query = `
    mutation create (
        $name: String
        $email: String
        $isPremium: Boolean
        $isDesignPartner: Boolean
      ) {
        response: createUser(
          name: $name
          email: $email
          isPremium: $isPremium
          isDesignPartner: $isDesignPartner
        ) ${USER}
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  fetchUserAttributes(variables) {
    const query = `
    query fetchUserAttributes (
      $userEmail: String!
    ) {
      response: fetchUserAttributes (
        userEmail: $userEmail
      ) {
        userEmail
        attributes {
          name
          value
        }
      }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  getUserGroups(variables) {
    const query = `
      query getUserGroups (
        $userId: String
      ) {
        response: getUserGroups (
          userId: $userId
        ) ${GROUP}
      }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  getAllUsers(variables) {
    const query = `
      query getAllUsers (
        $group: Groups
        $ascending: Boolean
        $limit: Int
        $nextToken: String
      ) {
        response: getAllUsers (
          group: $group
          limit: $limit
          ascending: $ascending

          nextToken: $nextToken
        ) ${USERS}
      }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  getAdminLibraryLinks(variables) {
    const query = `
      query getAdminLibraryLinks (
        $userId: String
      ) {
        response: getAdminLibraryLinks (
          userId: $userId
        ) ${ADMIN_LIBRARY_LINKS}
      }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  listCommunityCollections(variables) {
    const query = `
    query listCommunityCollections (
      $limit: Int
      $nextToken: String
    ){
      response: listCommunityCollections(
        limit: $limit
        nextToken: $nextToken
      ) {
        data{
          id
          libraryId
          name
          description
          logo
          lastModified
          creator{
            id
            name
            email
          }
          status
          productsCount
          rating
          ratingBoosting
        }
        nextToken
      }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  listFeatureFlags() {
    const query = `
    query listFeatureFlags {
      response: listFeatureFlags ${FEATURE_FLAG}
    }
    `;
    return API.graphql({
      query,
    });
  },
  listWorkspaces(variables) {
    const query = `query listWorkspaces($limit:Int, $nextToken:String)
    {
      response:listWorkspaces(
        limit:$limit,
        nextToken:$nextToken
        )${WORKSPACE_CONNECTION}
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  manageCollectionRatingBoost(variables) {
    const query = `
    mutation manageCollectionRatingBoost (
      $collectionId: String!
      $libraryId: String
      $number: Float!
      $operation: BoostOperations!
    ){
      response: manageCollectionRatingBoost(
        collectionId:$collectionId
        libraryId:$libraryId
        number:$number
        operation:$operation
      ) {
        id
        libraryId
        name
        rating
        ratingBoosting

      }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  manageWorkspaceV2(variables) {
    const query = `
    mutation manageWorkspace(
      $workspaceId: String!
      $type: WorkspaceType
      $allowPages: Boolean!
      $freeLicenses: Int
      $premiumLicenses: Int
      $guestLicenseLimit: Int
      $unlimitedUsers: Boolean
    ) {
     manageWorkspace(
      workspaceId : $workspaceId
      type : $type
      freeLicenses: $freeLicenses
      guestLicenseLimit: $guestLicenseLimit
      premiumLicenses: $premiumLicenses
      unlimitedUsers: $unlimitedUsers) {
       id
     }
     setWorkspaceAllowPages(
      workspaceId : $workspaceId
      allowPages: $allowPages) {
       id
     }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  modifyWorkspaceSubscription(variables) {
    const query = `
    mutation modifyWorkspaceSubscription(
      $currWorkspaceType: WorkspaceType!
      $newWorkspaceType: WorkspaceType!
      $workspaceId: String!
    ) {
     modifyWorkspaceSubscription(
      workspaceId : $workspaceId
      currWorkspaceType: $currWorkspaceType
      newWorkspaceType: $newWorkspaceType) {
        stripeSubscriptionId
     }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  resetExpiredUser(variables) {
    const query = `
    mutation reset (
        $email: String!
      ) {
        response: resetExpiredUser(
          email: $email
        ) {
          reset
        }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  searchUsers(variables) {
    const query = `
    query searchUsers (
        $searchString: String!
      ) {
        users: searchUsers(
          searchString: $searchString
        ) ${USER}
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  sendTemporaryPassword(variables) {
    const query = `
    mutation sendTemporaryPassword (
      $userId: String!
    ){
      sendTemporaryPassword(
        userId:$userId
      ) {
      id
      }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  setMaintenanceMode(variables) {
    const query = `
    mutation setMaintenanceMode (
      $enabled: Boolean!
    ){
      response: setMaintenanceMode(
        enabled: $enabled
      ) ${FEATURE_FLAG}
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  setMaintenanceMessage(variables) {
    const query = `
    mutation setMaintenanceMessage (
      $text: String!
    ){
      response: setMaintenanceMessage(
        text: $text
      ) ${FEATURE_FLAG}
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  setReadOnlyMode(variables) {
    const query = `
    mutation setReadOnlyMode (
      $enabled: Boolean!
    ){
      response: setReadOnlyMode(
        enabled: $enabled
      ) ${FEATURE_FLAG}
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  setWorkspaceVerified(variables) {
    const query = `
    mutation setWorkspaceVerified (
      $workspaceId: String!
      $verified: Boolean!
    ){
      setWorkspaceVerified(
        workspaceId: $workspaceId
        verified: $verified
      ) {
        id
      }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  updateUserAttributes(variables) {
    const query = `
    mutation updateUserAttributes (
      $userEmail: String!
      $attributes: [UserAttribute!]!
    ){
      updateUserAttributes(
        userEmail: $userEmail
        attributes: $attributes
      ) {
        success
        message
      }
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  toggleAppAccess(variables) {
    const query = `
    mutation toggleAppAccess (
      $userEmail: String!
      $access: Boolean!
    ){
      toggleAppAccess(
        userEmail: $userEmail
        access: $access
      )
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
  updateAdminLibraryLinks(variables) {
    const query = `
    mutation manage (
        $userId: String!
        $editLibrary: String
        $viewMasterLibrary: String
        $viewCollections: String
        $submitNewProduct: String
        $submitEqual: String
      ) {
        response: updateAdminLibraryLinks(
          userId: $userId
          editLibrary: $editLibrary
          viewMasterLibrary: $viewMasterLibrary
          viewCollections: $viewCollections
          submitNewProduct: $submitNewProduct
          submitEqual: $submitEqual
        ) ${ADMIN_LIBRARY_LINKS}
    }
    `;
    return API.graphql({
      query,
      variables,
    });
  },
};
